const urlify = (text = "") => {
  var urlRegex =
    /(\b(http?|https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;
  return text.replace(urlRegex, function (url) {
    return `<a target="_blank" style="color:#ffffff" href="${url}">${url}</a>`;
  });
};

export { urlify };
